import { ShiftTypeDTO, UserRightsEnum } from '@/generated'

export const NUMBER_OF_SECONDS_IN_ONE_HOUR = 3600
export const NUMBER_OF_MINUTES_IN_ONE_HOUR = 60
export const NUMBER_OF_SECONDS_IN_ONE_MINUTE = 60
export const NUMBER_OF_HOURS_IN_ONE_DAY = 24
export const ADMIN_ROLES: UserRightsEnum[] = [UserRightsEnum.TCC_IT, UserRightsEnum.HOSPITAL_IT]
export const NON_ADMIN_ROLES: UserRightsEnum[] = [
  UserRightsEnum.SPOKE,
  UserRightsEnum.HUB,
  UserRightsEnum.GOD_MODE,
  UserRightsEnum.CHIEF_PHYSICIAN,
  UserRightsEnum.EASY_RADIOLOGY,
  UserRightsEnum.HOSPITAL_PHYSICIAN,
  UserRightsEnum.TCC_PHYSICIAN
]
export const ACTIVE_SHIFTS: ShiftTypeDTO[] = [ShiftTypeDTO.FIRST_SHIFT, ShiftTypeDTO.BACKUP_SHIFT]
export const NO_ACTIVE_SHIFTS: ShiftTypeDTO[] = [
  ShiftTypeDTO.NO_SHIFT,
  ShiftTypeDTO.GOD_MODE,
  ShiftTypeDTO.CHIEF_PHYSICIAN
]
